import * as React from "react";

export default function TableHeader({
  
}) {
  return (
    <div style={{ width: "100%", display: "flex" }}>
    <div
      style={{
        width: "35%",
        padding: "20px 15px",
        background: "#EDEFF1",
        borderBottom: "2px solid black",
        borderRadius: "10px 0 0 0",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
      }}
    >
      <p>Training</p>
    </div>
    <div
      style={{
        width: "15%",
        padding: "20px 15px",
        background: "#EDEFF1",
        borderBottom: "2px solid black", display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
      }}
    >
      <p>Program Type</p>
    </div>
    <div
      style={{
        width: "25%",
        padding: "20px 15px",
        background: "#EDEFF1",
        borderBottom: "2px solid black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <p>Program Duration</p>
    </div>
    <div
      style={{
        width: "15%",
        padding: "20px 15px",
        background: "#EDEFF1",
        borderBottom: "2px solid black",

        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <p>No. of Sessions</p>
    </div>
    <div
      style={{
        width: "10%",
        padding: "20px 15px",
        background: "#EDEFF1",
        borderBottom: "2px solid black",
        borderRadius: "0 10px 0 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <p>Action</p>
    </div>
  </div>

  );
}
